import { Smartphone, PhoneMissed, Puzzle } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';

const CARDS = [
  {
    icon: Smartphone,
    title: 'Lost Mobile Leads',
    body: 'Sluggish mobile load times push impatient local customers straight to your competitor. 53% of visitors leave a site that takes over 3 seconds to open — you lose the lead before they ever see your work.',
    accent: 'text-red-400',
  },
  {
    icon: PhoneMissed,
    title: "The 'Phone Tag' Time Sink",
    body: 'Generic contact forms force you and your staff to waste hours every day chasing basic job details that a smart system would collect up front.',
    accent: 'text-amber-400',
  },
  {
    icon: Puzzle,
    title: 'Fragile Plugins That Crash',
    body: 'Automatic updates frequently break contact forms without warning — silently killing your customer pipeline while you keep paying monthly add-on fees.',
    accent: 'text-sky-400',
  },
];

export default function Problem() {
  return (
    <section id="why" data-testid="problem-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <Eyebrow>The Common Trap</Eyebrow>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl max-w-2xl">
            Template sites don't just sit there.{' '}
            <span className="text-gradient-gold">They cost you money.</span>
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} i={i + 1}>
              <div className="group h-full bg-[#0F1C33]/60 border border-slate-700/40 hover:border-amber-500/30 rounded-2xl p-8 transition-colors duration-500">
                <c.icon size={30} className={`${c.accent} mb-6 transition-transform duration-500 group-hover:-translate-y-1`} />
                <h3 className="font-display font-semibold text-xl mb-3">{c.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal i={4}>
          <div className="mt-10 border border-amber-500/20 bg-amber-500/5 rounded-2xl px-8 py-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
            <p className="text-slate-300 text-sm sm:text-base">
              Every slow landing page burns your Google Ads and Facebook marketing dollars on visitors who bounce.
            </p>
            <span className="font-mono-tech text-amber-300 text-sm tracking-widest whitespace-nowrap">PROTECT YOUR AD SPEND →</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
